/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RmaInspectionDto { 
    completedAt: string;
    inspectedBy: string;
    result: RmaInspectionDto.ResultEnum;
    failureReason?: string;
}
export namespace RmaInspectionDto {
    export const ResultEnum = {
        Passed: 'PASSED',
        Conditional: 'CONDITIONAL',
        Failed: 'FAILED'
    } as const;
    export type ResultEnum = typeof ResultEnum[keyof typeof ResultEnum];
}


